import React, { useEffect, useMemo, useState } from 'react';
import ReactDOM from 'react-dom';

const CallReminderPeopleModal = ({
  open,
  people = [],
  onClose,
  onConfirm,
  saving = false,
}) => {
  const [selected, setSelected] = useState(() => new Set(people));
  const [query, setQuery] = useState('');

  useEffect(() => {
    if (!open) return;
    setSelected(new Set(people));
    setQuery('');
  }, [open, people]);

  const filtered = useMemo(() => {
    const needle = query.trim().toLowerCase();
    if (!needle) return people;
    return people.filter((name) => String(name).toLowerCase().includes(needle));
  }, [people, query]);

  if (!open) return null;

  const toggle = (name) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(name)) next.delete(name);
      else next.add(name);
      return next;
    });
  };

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-[2100] overflow-y-auto">
      <div className="fixed inset-0 bg-black/50" onClick={onClose} />
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative w-full max-w-md rounded-lg bg-white shadow-xl dark:bg-gray-800">
          <div className="border-b border-gray-200 px-6 py-4 dark:border-gray-700">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
              Add to call reminder?
            </h3>
          </div>
          <div className="px-6 py-4">
            <p className="text-sm text-gray-600 dark:text-gray-300">
              Choose who to add to your call reminder:
            </p>
            <input
              value={query}
              onChange={(event) => setQuery(event.target.value)}
              placeholder="Search people"
              className="mt-3 w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-sky-400/40 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100"
            />
            <div className="mt-3 max-h-72 overflow-y-auto">
              {filtered.map((name) => (
                <label key={name} className="flex items-center gap-2 py-1.5 text-sm text-gray-800 dark:text-gray-100">
                  <input
                    type="checkbox"
                    checked={selected.has(name)}
                    onChange={() => toggle(name)}
                  />
                  <span>{name}</span>
                </label>
              ))}
              {!filtered.length ? (
                <p className="py-6 text-center text-sm text-gray-400">No matching people</p>
              ) : null}
            </div>
          </div>
          <div className="flex justify-end gap-3 border-t border-gray-200 px-6 py-4 dark:border-gray-700">
            <button
              type="button"
              onClick={onClose}
              className="rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200"
            >
              Not now
            </button>
            <button
              type="button"
              disabled={saving || selected.size === 0}
              onClick={() => onConfirm([...selected])}
              className="rounded-lg bg-sky-600 px-4 py-2 text-sm font-medium text-white hover:bg-sky-700 disabled:opacity-60"
            >
              {saving ? 'Adding…' : 'Add'}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default CallReminderPeopleModal;
